import React, { FC, useEffect } from 'react';

import { Col, Container, Row } from 'layout';

import { EurolandBundleProps } from './models';

import './EurolandBundle.scss';

const EurolandBundle: FC<EurolandBundleProps> = ({ module }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'euroland-integration';
    script.async = true;
    script.src = 'https://tools.eurolandir.com/tools/integration/latest/embed.js';

    window.eurolandClientCfg = window.eurolandClientCfg || [];
    window.eurolandClientCfg.push({ company: 'uk-rb' });
    window.eurolandClientCfg.push({ reg_key: null });
    window.eurolandClientCfg.push({ svc_url: 'https://tools.eurolandir.com/tools/' });

    const firstScript = document.getElementsByTagName('script')[0];
    if (!document.getElementById('euroland-integration')) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    return () => {
      document.getElementById('euroland-integration')?.remove();
      delete window.eurolandClientCfg;
    };
  }, []);

  return (
    <section className="euroland-container section">
      <Container>
        <Row>
          <Col sm="12" className="col--no-gutters">
            {module.title ? <h2 className="euroland-container__title h4">{module.title}</h2> : null}
            {module.description ? (
              <p className="euroland-container__description">{module.description}</p>
            ) : null}
            <div
              dangerouslySetInnerHTML={{
                __html: module.eurolandBundle,
              }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EurolandBundle;
